























































import {Component, Vue} from "vue-property-decorator";
import {MutationList as rootMutations} from '@/store/modules/root/mutation-list'
import {MutationList as ModalMutations} from "@/store/modules/modal/mutation-list";

@Component
export default class NavBar extends Vue {

    private rootNamespace = 'root/';
    private modalNamespace = 'modal/';

    get logged() {
        return this.$store.getters[this.rootNamespace + 'isUserAuthorized'];
    }

    get historyCounter(): number{
        return 1 + this.$store.getters[this.rootNamespace + 'getHistoryCount'];
    }

    toggleSidebar() {
        this.$store.commit(this.rootNamespace + rootMutations.TOGGLE_SIDEBAR);
    }

    showAuthorization(){
        this.$store.commit(`${this.modalNamespace}${ModalMutations.SET_AUTH_MODAL_VISIBILITY_TRUE}`);
    }
}
